import React from "react";
import { Box, Container, Typography } from '@mui/material';

interface FooterInternalProps {
  className?: string;
}

// Rodape UNICO de todas as telas logadas (decisao do Hilton, 25/09/2026). Antes havia duas
// versoes: 76 telas mostravam so o copyright e 5 (CRM, FAQ e Canais de WhatsApp) mostravam tres
// blocos com nove links que nao levavam a lugar nenhum — `#dashboard`, `#docs`, `#privacy`,
// `#terms` e companhia. Ficou a versao enxuta, que ja era a de fato.
// O espacamento vive no CSS (.footer-internal), nao aqui: a regra global tem duas classes e
// vencia o `sx` do MUI, entao manter os dois seria pedir divergencia.
const FooterInternal: React.FC<FooterInternalProps> = ({ className = "" }) => (
  <Box
    component="footer"
    className={`footer-internal ${className}`}
    sx={{
      backgroundColor: '#2D3748',
      color: 'white',
      mt: 'auto'
    }}
  >
    <Container>
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="body2">
          {`© ${new Date().getFullYear()} CLINIC4US. Todos os direitos reservados.`}
        </Typography>
      </Box>
    </Container>
  </Box>
);

export default FooterInternal;
